var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFood = function SvgFood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5H9l.111.75M15 7.5h6L19 21h-2M15 7.5V4l3-1",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15a3.08 3.08 0 0 0-.419-1.53 4.19 4.19 0 0 0-1.192-1.298 5.954 5.954 0 0 0-1.784-.867A7.329 7.329 0 0 0 8.5 11c-.722 0-1.437.104-2.105.305a5.953 5.953 0 0 0-1.784.867 4.19 4.19 0 0 0-1.192 1.297A3.08 3.08 0 0 0 3 15h11ZM4 21c-1 0-1-2-1-3h11c0 1 0 3-1 3H4Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgFood;